import React from 'react'
import Helmet from 'react-helmet'
import { backendURL } from '../../data/config.json'

//Components
import Fleet from '../../components/Fleet'

const PremiumEs = props => (
  <div className="page Premium">
  <Helmet
          title={`Vehículos Premiumos para alquilar | Budget Nicaragua`}
          meta={[
            {
              name: 'description',
              content:
                'Preguntas frecuentes sobre el alquiler de autos.',
            },
          ]}
          link={[
            {
              rel: 'alternate',
              hreflang: 'es',
              href:
                './en/fleet/premium',
            },
          ]}
        />
    <h1>Premium</h1>
    <Fleet
      lang={props.pathContext.langKey}
      types={props.data.dataJson.fleetTypes}
      fleet={props.data.dataJson.fleet}
      features={props.data.dataJson.fleetFeatures}
      category={5}
    />
  </div>
)

export const query = graphql`
  query PremiumES {
    dataJson(id: { regex: "/fleet/" }) {
      ...FleetData
    }
    allFile(filter: { relativeDirectory: { eq: "fleet" } }) {
      edges {
        node {
          name
          childImageSharp {
            resolutions {
              ...GatsbyImageSharpResolutions
            }
          }
        }
      }
    }
  }
`

export default PremiumEs



// WEBPACK FOOTER //
// ./src/pages/fleet/premium.es.js